import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.join');
import { OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-join',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.join/view.scss */
:host {
  display: block;
  height: 100%;
}

.privacy-page {
  min-height: 100vh;
  min-height: 100svh;
  padding: 84px 32px 26px;
  background: #f3f6fb;
  color: #25324c;
}

.privacy-shell {
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
}

.privacy-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 0 6px 27px;
}

.privacy-brand {
  display: inline-flex;
  align-items: center;
  text-decoration: none;
}

.privacy-brand img {
  width: 112px;
  height: auto;
}

.privacy-topbar-label {
  color: #6d7b92;
  font-size: 13px;
}

.privacy-card {
  overflow: hidden;
  border: 1px solid #e7edf6;
  border-radius: 28px;
  background: #fff;
  box-shadow: 0 20px 65px -30px rgba(35, 55, 103, 0.2);
}

.privacy-document {
  min-width: 0;
  padding: 34px 44px 30px;
}

.privacy-document-header h1 {
  margin: 0;
  color: #1d2c48;
  font-size: 28px;
  font-weight: 750;
  line-height: 1.4;
  letter-spacing: -1px;
  word-break: keep-all;
}

.privacy-policy-section {
  margin-top: 29px;
}

.privacy-policy-heading {
  display: flex;
  align-items: baseline;
  gap: 12px;
}

.privacy-policy-heading h2 {
  margin: 0;
  color: #2b3c57;
  font-size: 15px;
  line-height: 1.7;
  font-weight: 700;
  letter-spacing: -0.3px;
}

.privacy-policy-text {
  margin: 11px 0 0;
  color: #637188;
  font-size: 13px;
  line-height: 1.9;
  word-break: keep-all;
  overflow-wrap: anywhere;
}

.privacy-data-list {
  margin: 17px 0 0;
  padding: 0 18px;
  border: 1px solid #e9eef5;
  border-radius: 16px;
  background: #f8fafd;
  list-style: none;
}

.privacy-data-list li {
  display: flex;
  align-items: flex-start;
  gap: 13px;
  padding: 17px 0;
}

.privacy-data-list li + li {
  border-top: 1px solid #e6ecf4;
}

.privacy-data-icon {
  display: flex;
  flex: 0 0 32px;
  align-items: center;
  justify-content: center;
  height: 32px;
  border: 1px solid #e1e9f4;
  border-radius: 10px;
  color: #658bb3;
  background: #fff;
  font-size: 13px;
}

.privacy-data-list h3 {
  margin: 0 0 5px;
  color: #384c6a;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.5;
}

.privacy-data-list p {
  margin: 0;
  color: #738097;
  font-size: 12px;
  line-height: 1.8;
  word-break: keep-all;
  overflow-wrap: anywhere;
}

.privacy-retention {
  margin-top: 25px;
}

.privacy-actions {
  margin-top: 27px;
  padding-top: 21px;
  border-top: 1px solid #e9eef5;
}

.privacy-action-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}

.privacy-back {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  min-height: 44px;
  color: #718099;
  font-size: 12px;
  text-decoration: none;
}

.privacy-back i {
  font-size: 11px;
}

.privacy-back:hover {
  color: #255e99;
}

.privacy-continue {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 26px;
  min-height: 50px;
  padding: 12px 25px;
  border: 0;
  border-radius: 25px;
  color: #fff;
  background: linear-gradient(105deg, #137db9, #303783);
  box-shadow: 0 6px 14px rgba(41, 75, 148, 0.1490196078);
  font-size: 13px;
  font-weight: 650;
  cursor: pointer;
  transition: box-shadow 0.18s, filter 0.18s;
}

.privacy-continue i {
  font-size: 12px;
  opacity: 0.8;
}

.privacy-continue:hover {
  filter: brightness(1.1);
  box-shadow: 0 8px 20px rgba(41, 75, 148, 0.2196078431);
}

.privacy-page a:focus-visible, .privacy-page button:focus-visible {
  outline: 2px solid #2685c0;
  outline-offset: 4px;
}

.privacy-page-footer {
  margin-top: 24px;
  color: #8b96aa;
  text-align: center;
  font-size: 10px;
  letter-spacing: 0.5px;
}

.privacy-steps {
  display: flex;
  gap: 24px;
  margin: 0;
  padding: 23px 44px;
  border-bottom: 1px solid #e7edf6;
  background: #f8fafd;
  list-style: none;
}

.privacy-step {
  display: flex;
  flex: 1;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.privacy-step-number {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: 1px solid #dce4ef;
  border-radius: 50%;
  color: #8a97aa;
  font-size: 11px;
}

.privacy-step-label {
  color: #7c8a9f;
  font-size: 12px;
  line-height: 1.5;
}

.privacy-step.is-current .privacy-step-number {
  color: #fff;
  background: #28689f;
  border-color: #28689f;
}

.privacy-step.is-current .privacy-step-label {
  color: #285f93;
  font-weight: 700;
}

@media (max-width: 760px) {
  .privacy-page {
    padding: 85px 20px 24px;
  }
  .privacy-topbar {
    padding: 0 3px 22px;
  }
  .privacy-topbar-label {
    display: none;
  }
  .privacy-card {
    border-radius: 23px;
  }
  .privacy-steps {
    gap: 12px;
    padding: 20px 24px;
  }
  .privacy-step {
    flex-direction: column;
    gap: 8px;
    text-align: center;
  }
  .privacy-step-label {
    font-size: 11px;
    word-break: keep-all;
  }
  .privacy-document {
    padding: 27px 24px 26px;
  }
  .privacy-document-header h1 {
    font-size: 25px;
    letter-spacing: -0.8px;
  }
  .privacy-policy-section {
    margin-top: 25px;
  }
  .privacy-policy-heading h2 {
    font-size: 14px;
  }
  .privacy-data-list {
    padding: 0 13px;
  }
  .privacy-data-list li {
    gap: 10px;
  }
  .privacy-action-row {
    flex-direction: column-reverse;
    gap: 12px;
  }
  .privacy-continue {
    width: 100%;
  }
  .privacy-page-footer {
    font-size: 9px;
  }
}
@media (max-width: 380px) {
  .privacy-page {
    padding-left: 12px;
    padding-right: 12px;
  }
  .privacy-document {
    padding-left: 20px;
    padding-right: 20px;
  }
  .privacy-document-header h1 {
    font-size: 23px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .privacy-continue {
    transition: none;
  }
}
.privacy-step.is-complete .privacy-step-number {
  color: #3572a2;
  background: #eaf3fb;
  border-color: #dbe8f5;
}

.privacy-step.is-complete .privacy-step-label {
  color: #5d7c9b;
}

.email-document {
  padding: 48px 44px 28px;
}

.email-content {
  max-width: 420px;
  margin: 0 auto;
}

.email-content h1 {
  margin: 0 0 32px;
  color: #1d2c48;
  font-size: 28px;
  font-weight: 750;
  line-height: 1.4;
  letter-spacing: -0.8px;
}

.email-form {
  display: flex;
  flex-direction: column;
  gap: 22px;
}

.email-field label {
  display: block;
  margin: 0 0 9px;
  color: #34415a;
  font-size: 13px;
  font-weight: 650;
}

.email-input-wrap {
  position: relative;
}

.email-field-icon {
  position: absolute;
  top: 19px;
  left: 18px;
  color: #8a98ae;
  font-size: 15px;
  pointer-events: none;
}

.email-field input {
  width: 100%;
  height: 54px;
  padding: 0 17px;
  border: 1px solid #e3e9f2;
  border-radius: 13px;
  background: #f7f9fc;
  color: #25324c;
  font: inherit;
  font-size: 14px;
  outline: none;
  transition: border-color 0.18s, box-shadow 0.18s;
}

.email-input-wrap input {
  padding-left: 47px;
}

.email-field input::placeholder {
  color: #8a97ab;
  opacity: 1;
}

.email-field input:focus {
  border-color: #387dc1;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(56, 125, 193, 0.1215686275);
}

.email-field input:disabled {
  color: #687a93;
  background: #f0f3f8;
  opacity: 1;
  cursor: default;
}

.email-field input[aria-invalid=true] {
  border-color: #c45353;
}

.email-error {
  margin: 7px 0 0;
  color: #b54747;
  font-size: 12px;
  line-height: 1.6;
}

.email-error:empty {
  display: none;
}

.email-code-label {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: space-between;
  gap: 6px 12px;
  margin-bottom: 9px;
}

.email-code-label label {
  margin: 0;
}

.email-resend {
  min-height: 28px;
  margin: -5px 0;
  padding: 5px 0;
  border: 0;
  background: transparent;
  color: #326da5;
  font-size: 12px;
  cursor: pointer;
}

.email-resend:hover {
  text-decoration: underline;
}

.email-code-input {
  font-variant-numeric: tabular-nums;
  letter-spacing: 5px;
}

.email-code-input::placeholder {
  letter-spacing: 0;
}

.email-code-hint {
  margin: 8px 0 0;
  color: #7a889d;
  font-size: 11px;
  line-height: 1.6;
}

.email-submit {
  position: relative;
  width: 100%;
  margin-top: 3px;
}

.email-submit i {
  position: absolute;
  right: 22px;
}

.email-footer {
  display: flex;
  justify-content: center;
  margin-top: 19px;
}

.email-back {
  padding: 0 12px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
}

.email-back:hover {
  background: #f7f9fc;
}

.email-document button:disabled {
  opacity: 0.6;
  cursor: wait;
}

@media (max-width: 760px) {
  .email-document {
    padding: 32px 24px 23px;
  }
  .email-content h1 {
    margin-bottom: 27px;
    font-size: 25px;
  }
}
@media (max-width: 380px) {
  .email-document {
    padding-left: 20px;
    padding-right: 20px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .email-field input {
    transition: none;
  }
}
.community-document, .account-document {
  padding: 34px 44px 30px;
}

.signup-title {
  margin: 0 0 28px;
  color: #1d2c48;
  font-size: 28px;
  font-weight: 750;
  line-height: 1.4;
  letter-spacing: -0.8px;
}

[data-step-title]:focus {
  outline: none;
}

.community-options {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 13px;
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
}

.community-option {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 72px;
  min-width: 0;
  padding: 17px 19px;
  margin: 0;
  border: 1px solid #e3e9f2;
  border-radius: 14px;
  background: #f8fafd;
  cursor: pointer;
}

.community-option:hover {
  border-color: #9abbda;
}

.community-option:focus-within {
  outline: 2px solid #2685c0;
  outline-offset: 3px;
}

.community-option.is-selected {
  border-color: #4383b6;
  background: #edf5fc;
}

.community-option input {
  flex: 0 0 16px;
  width: 16px;
  height: 16px;
  margin: 0;
  accent-color: #28689f;
}

.community-option-name {
  min-width: 0;
  overflow-wrap: anywhere;
  color: #344d6d;
  font-size: 14px;
  font-weight: 650;
}

.community-option i {
  margin-left: auto;
  color: #367aaf;
  font-size: 12px;
}

.community-empty {
  margin: 18px 0;
  color: #718099;
  font-size: 13px;
}

.privacy-continue:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  box-shadow: none;
}

.account-document {
  max-width: 730px;
  margin: 0 auto;
}

.account-form {
  display: flex;
  flex-direction: column;
  gap: 22px;
}

.account-field-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 20px;
}

.account-field-grid .email-field {
  min-width: 0;
}

.account-form input[readonly] {
  color: #718099;
  background: #f0f3f8;
}

.account-id-row {
  display: flex;
  align-items: stretch;
  gap: 12px;
}

.account-id-row input {
  flex: 1;
  min-width: 0;
}

.account-id-check {
  flex-shrink: 0;
  padding: 0 18px;
  border: 1px solid #d4e1ef;
  border-radius: 13px;
  background: #f0f6fc;
  color: #2f6699;
  font-size: 13px;
  font-weight: 650;
  cursor: pointer;
}

.account-id-check:disabled {
  opacity: 0.6;
  cursor: wait;
}

.account-valid {
  margin: 7px 0 0;
  color: #25785c;
  font-size: 12px;
}

.account-form .privacy-actions {
  margin-top: 4px;
}

@media (max-width: 760px) {
  .privacy-steps {
    gap: 8px;
    padding: 20px 16px;
  }
  .privacy-step-label {
    font-size: 10px;
  }
  .community-document, .account-document {
    padding: 27px 24px 26px;
  }
  .signup-title {
    font-size: 25px;
  }
  .community-options {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
  }
  .community-option {
    min-height: 66px;
    padding: 14px 12px;
    gap: 8px;
  }
  .community-option-name {
    font-size: 13px;
  }
  .account-field-grid {
    grid-template-columns: minmax(0, 1fr);
    gap: 22px;
  }
}
@media (max-width: 380px) {
  .community-document, .account-document {
    padding-left: 20px;
    padding-right: 20px;
  }
  .community-option i {
    display: none;
  }
  .account-id-row {
    gap: 8px;
  }
  .account-id-check {
    padding: 0 12px;
  }
}
.email-countdown {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #326da5;
  font-size: 12px;
}

.email-countdown strong {
  margin-left: 3px;
  font-variant-numeric: tabular-nums;
  font-weight: 700;
}

.email-expired {
  color: #b43b40;
  font-size: 12px;
  line-height: 1.6;
}

.account-help {
  margin: 7px 0 0;
  color: #61738a;
  font-size: 12px;
  line-height: 1.7;
}

.account-help span {
  display: block;
}`],
})
export class PageJoinComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public communities: any[] = [];
    public communitiesLoading = true;
    public view = 'step1';
    public stepLabels = ['개인정보 동의', '커뮤니티 선택', '이메일 인증', '계정 정보 입력'];
    public errorMessages: any = {};
    public accountNameValid = '';
    public accountNameChecking = false;
    private checkedAccountName = '';
    public emailBusy = false;
    public signupPending = false;

    public data: any = {
        account_name: '', first_name: '', last_name: '', email: '',
        institution: '', department: '', community_id: '', pi_name: '',
        verified: false, verify: false, onetimepass: ''
    };

    public get stepNumber(): number { return Number(this.view.slice(4)); }


    public emailSeconds: number | null = null;
    private emailDeadline = 0;
    private emailTimer: ReturnType<typeof setInterval> | null = null;
    private emailClockDestroyed = false;

    public get emailTimeLeft(): string {
        const seconds = this.emailSeconds ?? 0;
        return `${String(Math.floor(seconds / 60)).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`;
    }

    private stopEmailClock(reset = true) {
        if (this.emailTimer !== null) clearInterval(this.emailTimer);
        this.emailTimer = null;
        if (reset) this.emailSeconds = null;
    }

    private syncEmailClock(data: any) {
        this.stopEmailClock();
        if (this.emailClockDestroyed || typeof data?.email_code_expires_at !== 'number'
            || typeof data?.server_time !== 'number'
            || !Number.isFinite(data.email_code_expires_at) || !Number.isFinite(data.server_time)) return;
        // Use server-relative time; browser clock skew and delayed interval callbacks
        // cannot restart the server-issued verification window or slow the countdown.
        this.emailDeadline = performance.now() + Math.max(0, data.email_code_expires_at - data.server_time) * 1000;
        const tick = () => {
            this.emailSeconds = Math.max(0, Math.ceil((this.emailDeadline - performance.now()) / 1000));
            if (this.emailSeconds === 0) this.stopEmailClock(false);
            this.service.render();
        };
        tick();
        if (this.emailSeconds > 0) this.emailTimer = setInterval(tick, 1000);
    }

    public ngOnDestroy() {
        this.emailClockDestroyed = true;
        this.stopEmailClock();
    }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(false, '/landing');
        await this.loadCommunities();
    }

    public async alert(message: string, status = 'error', cancel: any = false, action = '확인') {
        return await this.service.alert.show({
            title: '', message, cancel, actionBtn: status, action, status
        });
    }

    public async loadCommunities() {
        this.communitiesLoading = true;
        await this.service.render();
        try {
            const response: any = await wiz.call('get_communities');
            this.communities = response?.code === 200 && Array.isArray(response.data)
                ? response.data.sort((a, b) => a.name.localeCompare(b.name)) : [];
        } catch {
            this.communities = [];
        } finally {
            this.communitiesLoading = false;
            await this.service.render();
        }
    }

    public async selectCommunity(communityId: string) {
        this.data.community_id = communityId;
        this.errorMessages.community_id = '';
        await this.service.render();
    }

    private hasCommunity(): boolean {
        return this.communities.some(community => community.id === this.data.community_id);
    }

    public async step(view: string) {
        if (!['step1', 'step2', 'step3', 'step4'].includes(view)) return;
        if ((view === 'step3' || view === 'step4') && !this.hasCommunity()) {
            this.errorMessages.community_id = '커뮤니티를 선택해주세요.';
            view = 'step2';
        } else if (view === 'step4' && !this.data.verified) {
            view = 'step3';
        }
        this.view = view;
        await this.service.render();
        const title = document.querySelector<HTMLElement>('wiz-page-join [data-step-title]');
        title?.focus({ preventScroll: true });
        document.querySelector('app-root')?.scrollTo({ top: 0 });
    }

    public resetAccountNameCheck() {
        this.checkedAccountName = '';
        this.accountNameValid = '';
        this.errorMessages.account_name = '';
        this.service.render();
    }

    public resetPiNameError() {
        this.errorMessages.pi_name = '';
        this.service.render();
    }

    public async checkAccountName() {
        if (this.accountNameChecking) return;
        this.resetAccountNameCheck();
        const accountName = this.data.account_name;
        if (!this.validateAccountName(accountName)) {
            this.errorMessages.account_name = '아이디는 영문 소문자 또는 밑줄로 시작하는 1~64자의 소문자·숫자·밑줄·점·하이픈이어야 합니다.';
            await this.service.render();
            return;
        }
        this.accountNameChecking = true;
        await this.service.loading.show();
        try {
            const response: any = await wiz.call('check_account_name', { account_name: accountName });
            if (accountName !== this.data.account_name) return;
            if (response?.code === 200) {
                this.checkedAccountName = accountName;
                this.accountNameValid = '사용 가능한 아이디입니다.';
            } else {
                this.errorMessages.account_name = response?.data || '아이디 중복 확인을 해주세요.';
            }
        } catch {
            if (accountName === this.data.account_name)
                this.errorMessages.account_name = '아이디 중복 여부를 확인하지 못했습니다. 잠시 후 다시 확인해주세요.';
        } finally {
            this.accountNameChecking = false;
            await this.service.loading.hide();
            await this.service.render();
        }
    }

    public async submitEmail() {
        if (this.emailBusy || this.service.loading.isshow) return;
        if (!this.hasCommunity()) return this.step('step2');
        if (this.data.verified) return this.step('step4');
        this.emailBusy = true;
        await this.service.render();
        try {
            if (this.data.verify) await this.emailVerify(this.data.email, this.data.onetimepass);
            else await this.join_email_check();
        } finally {
            this.emailBusy = false;
            await this.service.render();
        }
    }

    public async join_email_check() {
        const response: any = await wiz.call('emailCheck', { email: this.data.email });
        if (response?.code === 301) {
            this.data.verify = true;
            await this.emailAuthentication(this.data.email);
            await this.service.render();
            return;
        }
        await this.alert('사용할 수 없는 이메일입니다.');
    }

    public async emailAuthentication(email: string, showstatus = true) {
        await this.service.loading.show();
        let response: any;
        try {
            response = await wiz.call('emailAuthentication', { email });
        } finally {
            await this.service.loading.hide();
        }
        if (response?.code === 200) {
            this.data.onetimepass = '';
            this.syncEmailClock(response.data);
        }
        if (!showstatus) return;
        if (response?.code === 200) {
            await this.alert('이메일 인증 코드가 발송되었습니다', 'success');
        } else {
            await this.alert('이메일 인증 코드 발송 중 오류가 발생했습니다', 'error');
        }
    }

    public async emailVerify(email: string, onetimepass: string) {
        await this.service.loading.show();
        let response: any;
        try {
            response = await wiz.call('emailVerify', { email, onetimepass });
        } finally {
            await this.service.loading.hide();
        }
        if (response?.code === 200) {
            this.data.verified = true;
            this.stopEmailClock();
            await this.step('step4');
        } else {
            await this.alert(response?.data || '잘못된 인증번호 입니다.', 'error');
        }
    }

    public async join() {
        if (this.signupPending || this.accountNameChecking) return;
        if (!this.hasCommunity()) return this.step('step2');
        if (!this.data.verified) return this.step('step3');
        this.errorMessages = {};
        const piName = typeof this.data.pi_name === 'string' ? this.data.pi_name.trim().normalize('NFC') : '';
        if (Array.from(piName).length > 128) this.errorMessages.pi_name = 'PI 성명은 128자 이내로 입력해주세요.';
        if (!this.data.account_name) this.errorMessages.account_name = '아이디를 입력해주세요.';
        else if (!this.validateAccountName(this.data.account_name)) this.errorMessages.account_name = '아이디는 영문 소문자 또는 밑줄로 시작하는 1~64자의 소문자·숫자·밑줄·점·하이픈이어야 합니다.';
        else if (this.checkedAccountName !== this.data.account_name) this.errorMessages.account_name = '아이디 중복 확인을 해주세요.';
        if (!this.data.first_name) this.errorMessages.first_name = '이름을 입력해주세요.';
        if (!this.data.last_name) this.errorMessages.last_name = '성을 입력해주세요.';
        if (!this.validateEmail(this.data.email)) this.errorMessages.email = '올바른 이메일 형식이 아닙니다.';
        if (Object.keys(this.errorMessages).length) {
            await this.service.render();
            return;
        }

        this.signupPending = true;
        await this.service.loading.show();
        try {
            // Only account details are submitted. Role and base group are resolved by the server.
            const user = {
                email: this.data.email,
                onetimepass: this.data.onetimepass,
                account_name: this.data.account_name,
                first_name: this.data.first_name,
                last_name: this.data.last_name,
                institution: this.data.institution,
                department: this.data.department,
                pi_name: piName,
                community_id: this.data.community_id,
                // The server generates the portal-only secret.
            };
            const response: any = await wiz.call('join', user);
            if (response?.code === 200) {
                await this.service.alert.success(typeof response.data === 'string' ? response.data : '회원가입 요청이 성공적으로 접수되었습니다.');
                await this.router.navigate(['/login']);
            } else {
                if (response?.data?.email_verification_required) {
                    this.data.verified = false;
                    this.data.verify = false;
                    this.data.onetimepass = '';
                    this.stopEmailClock();
                    await this.step('step3');
                }
                await this.service.alert.error(response?.data?.message || response?.data || '회원가입 요청에 실패했습니다.');
            }
        } catch (error) {
            console.error('회원가입 중 오류 발생:', error);
            this.service.alert.error('회원가입 처리 중 오류가 발생했습니다.');
        } finally {
            this.signupPending = false;
            await this.service.loading.hide();
        }
    }

    public validateAccountName(accountName: string): boolean { return /^[a-z_][a-z0-9_.-]{0,63}$/.test(accountName); }
    public validateEmail(email: string): boolean { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email); }
}

export default PageJoinComponent;